/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponsePagedResultVideoTutorial } from '../../models/api-response-paged-result-video-tutorial';
import { PagedRequestVideoTutorialSearchReq } from '../../models/paged-request-video-tutorial-search-req';

export interface GetListVideoTutorial$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
      body: PagedRequestVideoTutorialSearchReq
}

export function getListVideoTutorial(http: HttpClient, rootUrl: string, params: GetListVideoTutorial$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePagedResultVideoTutorial>> {
  const rb = new RequestBuilder(rootUrl, getListVideoTutorial.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponsePagedResultVideoTutorial>;
    })
  );
}

getListVideoTutorial.PATH = '/v1/api/admin-ui/video-tutorial/list';
